import { TextField, Stack, FormControl } from "@mui/material";

/**
 * Renders token input for Bearer authentication
 */
const renderBearerInputs = ({
    register,
    originalValues = [],
    onFieldChange,
    onFieldFocus,
    isEditMode,
    errors = {} as any,
}) => {
    return (
        <Stack direction="column" gap={2}>
            <FormControl className="form-control-bg-white">
                <TextField
                    label="Token"
                    variant="outlined"
                    required
                    {...register("auth_header.values.0.field", {
                        required: "Token is required",
                        onChange: (e) => {
                            if (e.target.value && e.target.value.trim()) {
                                onFieldChange(0);
                            }
                        },
                    })}
                    onFocus={(e) => {
                        if (onFieldFocus(0, originalValues[0])) {
                            e.target.value = "";
                        }
                    }}
                    error={!!(errors.auth_header as any)?.values?.[0]?.field}
                    helperText={
                        (errors.auth_header as any)?.values?.[0]?.field?.message
                    }
                    placeholder={
                        isEditMode && originalValues[0] ? "••••••" : ""
                    }
                    style={{ width: "100%" }}
                    className="text-field-ui-workaround"
                />
            </FormControl>
        </Stack>
    );
};

const renderNoAuthInputs = () => {
    return <></>;
};

/**
 * Renders username and password inputs for Basic authentication
 */
const renderBasicInputs = ({
    register,
    originalValues = [],
    onFieldChange,
    onFieldFocus,
    isEditMode,
    errors = {} as any,
}) => {
    return (
        <Stack direction="column" gap={2}>
            <FormControl className="form-control-bg-white">
                <TextField
                    label="Username"
                    variant="outlined"
                    required
                    {...register("auth_header.values.0.field", {
                        required: "Username is required",
                        onChange: (e) => {
                            if (e.target.value && e.target.value.trim()) {
                                onFieldChange(0);
                            }
                        },
                    })}
                    onFocus={(e) => {
                        if (onFieldFocus(0, originalValues[0])) {
                            e.target.value = "";
                        }
                    }}
                    error={!!(errors.auth_header as any)?.values?.[0]?.field}
                    helperText={
                        (errors.auth_header as any)?.values?.[0]?.field?.message
                    }
                    placeholder={
                        isEditMode && originalValues[0] ? "••••••" : ""
                    }
                    style={{ width: "100%" }}
                    className="text-field-ui-workaround"
                />
            </FormControl>
            <FormControl className="form-control-bg-white">
                <TextField
                    label="Password"
                    variant="outlined"
                    required
                    {...register("auth_header.values.1.field", {
                        required: "Password is required",
                        onChange: (e) => {
                            if (e.target.value && e.target.value.trim()) {
                                onFieldChange(1);
                            }
                        },
                    })}
                    onFocus={(e) => {
                        if (onFieldFocus(1, originalValues[1])) {
                            e.target.value = "";
                        }
                    }}
                    error={!!(errors.auth_header as any)?.values?.[1]?.field}
                    helperText={
                        (errors.auth_header as any)?.values?.[1]?.field?.message
                    }
                    placeholder={
                        isEditMode && originalValues[1] ? "••••••" : ""
                    }
                    style={{ width: "100%" }}
                    className="text-field-ui-workaround"
                />
            </FormControl>
        </Stack>
    );
};

/**
 * Renders variable input for API Key authentication
 */
const renderApiKeyInputs = ({
    register,
    originalValues = [],
    onFieldChange,
    onFieldFocus,
    isEditMode,
    errors = {} as any,
}) => {
    return (
        <Stack direction="column" gap={2}>
            <FormControl className="form-control-bg-white">
                <TextField
                    label="Variable"
                    variant="outlined"
                    required
                    {...register("auth_header.values.0.field", {
                        required: "Variable is required",
                        onChange: (e) => {
                            if (e.target.value && e.target.value.trim()) {
                                onFieldChange(0);
                            }
                        },
                    })}
                    onFocus={(e) => {
                        if (onFieldFocus(0, originalValues[0])) {
                            e.target.value = "";
                        }
                    }}
                    error={!!(errors.auth_header as any)?.values?.[0]?.field}
                    helperText={
                        (errors.auth_header as any)?.values?.[0]?.field?.message
                    }
                    placeholder={
                        isEditMode && originalValues[0] ? "••••••" : ""
                    }
                    style={{ width: "100%" }}
                    className="text-field-ui-workaround"
                />
            </FormControl>
        </Stack>
    );
};

export {
    renderBearerInputs,
    renderNoAuthInputs,
    renderBasicInputs,
    renderApiKeyInputs,
};
